import { useI18n } from "../i18n/I18nProvider";

/**
 * Frame 5:141: TDCO block on the left, Qurtuba mark centred, bond logo on the
 * right in both locales, so the row is pinned to left-to-right order.
 */
export function Footer() {
  const { copy, direction } = useI18n();

  return (
    <footer className="border-t border-line-2 bg-footer">
      <div
        dir="ltr"
        className="flex h-[130px] items-center justify-between gap-6 mx-auto w-full max-w-[1440px] px-[18px] lg:px-[72px] py-5 lg:h-[180px] lg:py-0"
      >
        <div className="flex flex-col items-start gap-[7px]" data-reveal>
          <img
            src="/logos/logo-tdco.png"
            alt="TDCO"
            width={138}
            height={30}
            className="h-[20px] w-auto lg:h-[30px]"
          />
          <span dir={direction} className="text-[11px] leading-[20.6px] text-body">
            {copy.footer.developer}
          </span>
        </div>
        <img
          src="/logos/logo-qurtuba.png"
          alt={copy.brand.projectName}
          width={70}
          height={92}
          data-reveal
          className="h-[54px] w-auto lg:h-[92px]"
        />
        <img
          src="/logos/logo-bond.png"
          alt="bond"
          width={130}
          height={42}
          data-reveal
          className="h-[37px] w-auto lg:h-[42px]"
        />
      </div>
    </footer>
  );
}
